import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import AdminDashboard from "./components/admin/AdminDashboard";
import { Toaster } from "./components/ui/toaster";
import { AnalyticsProvider } from "./contexts/AnalyticsContext";
import { SiteContentProvider } from "./contexts/SiteContentContext";

function App() {
  return (
    <AnalyticsProvider>
      <SiteContentProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/grantpilot" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </div>
      </SiteContentProvider>
    </AnalyticsProvider>
  );
}

export default App;